import { integrationOptionsAtom } from '@/atoms/integrationAtoms';
import { type RootState } from '@/store';
import { Button } from '@heidi/design-system/button';
import { useAtomValue } from 'jotai';
import { ArrowLeft } from 'lucide-react';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

export function IntegrationHeader() {
  const integrationOptions = useAtomValue(integrationOptionsAtom);
  const isRunning = useSelector((state: RootState) => state.timerModel.isRunning);

  const onNavigateBack = useCallback(() => {
    if (!integrationOptions?.ehrBaseUrl) {
      return;
    }

    window.location.href = integrationOptions.ehrBaseUrl;
  }, [integrationOptions?.ehrBaseUrl]);

  if (!integrationOptions?.banner || !integrationOptions?.ehrBaseUrl) {
    return null;
  }

  return (
    <div className="pointer-events-auto z-[10000] flex w-full items-center justify-between bg-surface p-0 px-4 shadow-sm sm:hidden">
      <Button
        size="lg"
        variant="link"
        className="m-0 cursor-pointer p-0 text-text-secondary outline-0"
        onClick={onNavigateBack}
        disabled={isRunning}
      >
        <ArrowLeft className="rtl:-scale-x-100" />
        <FormattedMessage
          defaultMessage="Return to {ehrName}"
          id="yMgA74EfhV"
          values={{ ehrName: integrationOptions.ehrName }}
        />
      </Button>
    </div>
  );
}
